<template>
  <div class="text-center text-muted my-4 py-4">
    <div class="mb-3">
      <i :class="iconClass" style="font-size: 48px; opacity: 0.5;"></i>
    </div>
    <h5 class="text-muted">{{ message }}</h5>
    <p class="text-muted small" v-if="subMessage">{{ subMessage }}</p>
  </div>
</template>

<script>
export default {
  name: "NoDataMessage",
  props: {
    /**
     * Type of empty state: 'empty', 'no-filter', 'no-results', 'no-search'
     */
    type: {
      type: String,
      default: "empty",
      validator: (value) =>
        ["empty", "no-filter", "no-results", "no-search", "custom"].includes(
          value
        ),
    },
    /**
     * Custom message (used when type='custom')
     */
    customMessage: {
      type: String,
      default: "",
    },
    /**
     * Custom sub-message
     */
    customSubMessage: {
      type: String,
      default: "",
    },
  },
  computed: {
    message() {
      if (this.type === "custom") {
        return this.customMessage;
      }

      const messages = {
        empty: "No Data Available",
        "no-filter":
          "Select filters and click 'Filter' to view data",
        "no-results": "No data found matching your criteria",
        "no-search": "No matching records found",
      };

      return messages[this.type] || messages.empty;
    },
    subMessage() {
      if (this.customSubMessage) {
        return this.customSubMessage;
      }

      const subMessages = {
        empty: "There is no data to display at this time",
        "no-filter": "Use the filter options above to search",
        "no-results": "Try adjusting your filter criteria",
        "no-search": "Try a different search term",
      };

      return subMessages[this.type] || "";
    },
    iconClass() {
      const icons = {
        empty: "mdi mdi-inbox-multiple-outline",
        "no-filter": "mdi mdi-filter-outline",
        "no-results": "mdi mdi-magnify-close",
        "no-search": "mdi mdi-magnify",
      };

      return icons[this.type] || icons.empty;
    },
  },
};
</script>

<style scoped>
.text-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
